import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "pagestyle" }

import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Orders',
  setup(__props) {

  const searchForm = reactive({
    memberid:'',
    companyid:'',
    words:'',
    limit:10,
    page:1,
  })
  const baseData:any = reactive({
    companylist:[],
    loading:false,
    title:'',
    userbox:false,
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const getList = () => {
    baseData.loading = true
    api.orderApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        tableData.data = res.data.list
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const changeStatus = (id:number,status:number) => {
    baseData.loading = true
    api.orderApi.changeStatus({id:id,status:status}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const getCompanyList = () => {
    baseData.loading = true
    api.companyApi.list({limit:10000,page:1}).then((res:any)=>{
      baseData.loading = false
      let companylist = []
      if(res.code==200){
        for(var i in res.data.list){
            if(res.data.list[i].status==1){
                companylist.push(res.data.list[i])
            }
        }
        baseData.companylist = companylist
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const search = () => {
    searchForm.page = 1
    getList()
  }
  const reset = () => {
    searchForm.page = 1
    searchForm.limit = 10
    searchForm.words = ""
    searchForm.companyid = ""
    getList()
  }
  onMounted(() => {
    getList()
    getCompanyList()
  })
  
return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_breadcrumb, {
            class: "breadcrumb",
            separator: "/"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
                default: _withCtx(() => [
                  _createTextVNode("工作台")
                ]),
                _: 1
              }),
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("订单列表")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: searchForm,
          inline: "",
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "分享人ID" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: searchForm.memberid,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.memberid) = $event)),
                  placeholder: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "公司" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: searchForm.companyid,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.companyid) = $event)),
                  placeholder: "请选择",
                  style: {"width":"240px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.companylist, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.title,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "关键词" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: searchForm.words,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchForm.words) = $event)),
                  placeholder: "公司|备注"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: search
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("搜索")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: reset }, {
                  default: _withCtx(() => [
                    _createTextVNode("重置")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"20px"}
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          "row-key": "id",
          border: "",
          data: tableData.data,
          style: {"width":"100%","margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "ID",
              width: "60"
            }),
            _createVNode(_component_el_table_column, {
              label: "分享人",
              width: "160"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.nickname) + " (ID:" + _toDisplayString(scope.row.memberid) + ") ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "company",
              label: "公司"
            }),
            _createVNode(_component_el_table_column, {
              prop: "total",
              label: "价格（元）",
              width: "160"
            }),
            _createVNode(_component_el_table_column, {
              prop: "remark",
              label: "备注",
              width: "240"
            }),
            _createVNode(_component_el_table_column, {
              prop: "created_at",
              label: "创建时间",
              width: "160"
            }),
            _createVNode(_component_el_table_column, {
              label: "状态",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                (scope.row.status == 1)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_2, "待支付"))
                  : _createCommentVNode("", true),
                (scope.row.status == 2)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, "已支付"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: "操作",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                (scope.row.status == 1)
                  ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                      key: 0,
                      "confirm-button-text": "Yes",
                      "cancel-button-text": "No",
                      title: "你确定要改成支付状态?",
                      onConfirm: ($event: any) => (changeStatus(scope.row.id,2))
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "success"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("已支付")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onConfirm"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, baseData.loading]
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_pagination, {
            "current-page": searchForm.page,
            "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((searchForm.page) = $event)),
            "page-size": searchForm.limit,
            "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((searchForm.limit) = $event)),
            layout: "sizes, prev, pager, next",
            total: tableData.total,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total"])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})